// firebase.js
import { initializeApp, getApps, getApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore, doc, setDoc, getDoc, collection, addDoc } from "firebase/firestore";
import {
  getAuth,
  GoogleAuthProvider,
  setPersistence,
  browserLocalPersistence,
  onAuthStateChanged,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  signInWithPopup,
} from "firebase/auth";

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCiyqfzQgyByQHozN1TlQo6JgIWp2POdS4",
  authDomain: "powersense-iot.firebaseapp.com",
  projectId: "powersense-iot",
  storageBucket: "powersense-iot.firebasestorage.app",
  messagingSenderId: "725275243512",
  appId: "1:725275243512:web:a28a01960fda2ab64adc0d"
};

// Initialize Firebase only if it hasn't been initialized yet
const app = !getApps().length ? initializeApp(firebaseConfig) : getApp();
const analytics = getAnalytics(app);
const db = getFirestore(app);
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();

// Set persistence to LOCAL
setPersistence(auth, browserLocalPersistence).catch((error) => {
  console.error("Error setting persistence:", error);
});

// Export all necessary instances and functions
export {
  app,
  db,
  auth,
  analytics,
  googleProvider,
  doc,
  setDoc,
  getDoc,
  collection,
  addDoc,
  onAuthStateChanged,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  signInWithPopup,
};